/**
 * La ⓘ que explica el estado del producto (pp-estado-ayuda.liquid).
 *
 * POR QUÉ HAY JS Y NO SOLO :hover
 * En celular no existe el hover. Padrino pidió explícitamente que "le puedan
 * picar", así que el clic es el mecanismo principal y el hover es el extra
 * para quien trae mouse.
 *
 * DELEGACIÓN, NO UN LISTENER POR TARJETA
 * Una colección pinta hasta 50 tarjetas y cada una puede traer su ⓘ. Con un
 * listener por botón serían 50 suscripciones que además habría que volver a
 * colgar cada vez que el filtro repinta la lista por fetch. Un solo listener
 * en el documento funciona igual para las tarjetas que ya están y para las que
 * lleguen después.
 *
 * NO DEPENDE DEL id PARA FUNCIONAR
 * El `aria-controls` lleva un id porque la accesibilidad lo pide, pero el JS
 * busca la burbuja como HERMANA dentro del mismo envoltorio. Así, si algún día
 * el mismo producto se pinta dos veces en una página y los ids se repiten, el
 * tooltip sigue abriendo el suyo y no el del vecino.
 */
(function () {
  'use strict';

  var ABIERTO = 'is-open';
  var abierto = null;

  function burbujaDe(btn) {
    var wrap = btn.closest('[data-pp-estado-ayuda]');
    return wrap ? wrap.querySelector('.pp-estado-ayuda__burbuja') : null;
  }

  function cerrar() {
    if (!abierto) return;
    var b = burbujaDe(abierto);
    if (b) {
      b.hidden = true;
      b.classList.remove(ABIERTO);
    }
    abierto.setAttribute('aria-expanded', 'false');
    abierto = null;
  }

  /**
   * Coloca la burbuja en coordenadas de VIEWPORT.
   *
   * La tarjeta lleva `overflow: hidden` para que la foto respete las esquinas
   * redondeadas, así que una burbuja absoluta se recortaba contra su borde: en
   * vista lista la fila mide ~76px y solo se leía el último renglón. Con
   * posición fija sale de todos los ancestros, pero las coordenadas hay que
   * calcularlas — esto es ese cálculo.
   */
  function colocar(btn, b) {
    var MARGEN = 8;
    var r = btn.getBoundingClientRect();

    // Se mide con la burbuja ya visible: oculta, ancho y alto son 0.
    var ancho = b.offsetWidth;
    var alto = b.offsetHeight;

    // Arriba por defecto. Si no cabe, abajo — pasa en las primeras filas de la
    // lista, que quedan pegadas al borde superior de la pantalla.
    var cabeArriba = r.top - alto - MARGEN >= 0;
    b.classList.toggle('pp-estado-ayuda__burbuja--abajo', !cabeArriba);
    var top = cabeArriba ? r.top - alto - MARGEN : r.bottom + MARGEN;

    // Alineada a la izquierda del ícono, pero sin salirse de la pantalla por
    // ningún lado: la ⓘ suele caer cerca del borde derecho de la tarjeta.
    var left = r.left - 12;
    var maxLeft = window.innerWidth - ancho - MARGEN;
    if (left > maxLeft) left = maxLeft;
    if (left < MARGEN) left = MARGEN;

    b.style.top = Math.round(top) + 'px';
    b.style.left = Math.round(left) + 'px';
    // El piquito apunta al centro del botón aunque la burbuja se haya recorrido.
    b.style.setProperty('--pp-tip-flecha', Math.round(r.left + r.width / 2 - left) + 'px');
  }

  function abrir(btn) {
    if (abierto === btn) return cerrar();
    cerrar();
    var b = burbujaDe(btn);
    if (!b) return;
    b.hidden = false;
    b.classList.add(ABIERTO);
    colocar(btn, b);
    btn.setAttribute('aria-expanded', 'true');
    abierto = btn;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pp-estado-ayuda-btn]');
    if (btn) {
      // La tarjeta COMPLETA es un enlace al producto. Sin esto, picar la ⓘ
      // navegaría a la ficha y el cliente nunca vería la explicación.
      e.preventDefault();
      e.stopPropagation();
      abrir(btn);
      return;
    }
    cerrar();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });

  // Las coordenadas se calculan al abrir; si la página se mueve, la burbuja se
  // quedaría flotando lejos de su ⓘ. Cerrarla es más honesto que perseguirla
  // en cada frame de scroll. `passive` para no estorbarle al scroll.
  window.addEventListener('scroll', cerrar, { passive: true, capture: true });
  window.addEventListener('resize', cerrar, { passive: true });

  // Hover solo para quien trae mouse. `matchMedia` en vez de detectar el
  // ancho: un iPad grande no tiene cursor y abriría la burbuja al rozarlo.
  var conMouse = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  if (conMouse) {
    document.addEventListener('mouseover', function (e) {
      var btn = e.target.closest && e.target.closest('[data-pp-estado-ayuda-btn]');
      if (btn && abierto !== btn) abrir(btn);
    });
    document.addEventListener('mouseout', function (e) {
      var wrap = e.target.closest && e.target.closest('[data-pp-estado-ayuda]');
      if (!wrap || !abierto) return;
      // No cerrar si el cursor sigue dentro del mismo envoltorio (pasa al
      // moverse del botón a la burbuja).
      if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;
      if (wrap.contains(abierto)) cerrar();
    });
  }
})();
